



















import Vue from 'vue';
export default Vue.extend({
    data() {
        return {
            startTime: '2024/03/18 20:00',
            finishTime: '2024/03/18 22:00',
        };
    },
    props: {
        maintenanceLp: Boolean,
    },
});
